<script setup>
import { defineEmits, defineProps, ref } from "vue";
import { saveQnA } from "@/api";
import useModal from "@/composables/useModal";

const props = defineProps({
  productTextName: String,
  productId: Number,
});

const emits = defineEmits(["submit", "close"]);

const { alert, confirm } = useModal();

const content = ref("");
const isSecret = ref(false);
const password = ref("");

async function onSubmit() {
  if (!content.value) {
    alert("문의 내용을 입력해주세요");
    return;
  }

  if (isSecret.value && !password.value) {
    alert("비밀번호를 입력해주세요.");
    return;
  }

  if (!(await confirm("저장하시겠습니까?"))) {
    return;
  }

  await saveQnA({
    productId: props.productId,
    content: escapeRegex(content.value),
    isSecret: isSecret.value ? "Y" : "N",
    password: password.value,
  });

  emits("submit", true);
}

function escapeRegex(string) {
  if (string) {
    return string.replace(/[-/\\^$%*+?.()|[\]{}<>]/g, " ");
  } else {
    return string;
  }
}
</script>

<template>
  <div class="popup-bg on"></div>
  <div class="popup-cont w01 on" id="popup-goods">
    <div class="popup-header">
      <h3 class="title">상품문의</h3>
      <button type="button" class="popup-close-btn" @click="$emit('close')">
        닫기
      </button>
    </div>
    <div class="popup-body">
      <p class="goods_title">
        {{ productTextName }}
      </p>
      <div class="popup_write type-02">
        <div class="input_wrap">
          <form @submit.prevent="onSubmit">
            <p class="input_tit">
              문의 내용<strong class="required">*</strong>
            </p>
            <div class="input_area">
              <textarea
                name="askDetailWrite"
                id="askDetailWrite"
                placeholder="상품의 대한 문의 이외에 즉시 확인이 필요한 주문 관련 문의는 판매처에 전화문의 부탁드립니다."
                v-model="content"
              ></textarea>
            </div>
            <p class="input_tit">비밀 글 설정</p>
            <div class="chk_area">
              <input
                type="checkbox"
                name="secretChkWrite"
                id="secretChkWrite"
                v-model="isSecret"
              />
              <label for="secretChkWrite" class="chk">
                <i class="ico_chk"></i>
                비밀글 선택 시 작성자만 조회 가능합니다.
              </label>
            </div>
            <div class="input_area">
              <input
                type="password"
                name="passwordWrite"
                id="passwordWrite"
                v-model="password"
              />
            </div>
            <div class="btn_area">
              <button type="submit" class="btn form02">저장</button>
              <button type="button" class="btn" @click="$emit('close')">
                취소
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.popup-cont {
  padding-bottom: 30px;
}
</style>
